import { useEffect, useState } from "react";


const ChartStyle = ((props) => {

    // const data = props.result;

    const [ChartStatistic, setChartStatistic] = useState();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        SortData(props.result);
    }, [props]);

    const SortData = ((data) => {
        let arr = {
            'left': 0,
            'right': 0,
            '3Line': 0,
            '4Line': 0,
            'oddtype': 0,
            'eventype': 0,
            'type1': 0,
            'type2': 0,
            'type3': 0,
            'type4': 0,
        };

        data.map((item, index) => {

            if (item.ball_1 % 2 == 0) { arr['left']++; }

            if (item.ball_1 % 2 != 0) { arr['right']++; }

            if (item.ball_1 <= 14) { arr['3Line']++; }

            if (item.ball_1 > 14) { arr['4Line']++; }




            // RIGHT | 3LINE
            if (item.ball_1 % 2 != 0 && item.ball_1 <= 14) {
                arr['oddtype']++;
                arr['type3']++;
            }

            // LEFT | 3LINE
            if (item.ball_1 % 2 == 0 && item.ball_1 <= 14) {
                arr['eventype']++;
                arr['type2']++;
            }

            // RIGHT | 4LINE
            if (item.ball_1 % 2 != 0 && item.ball_1 > 14) {
                arr['oddtype']++;
                arr['type1']++;

            }

            // LEFT | 4LINE
            if (item.ball_1 % 2 == 0 && item.ball_1 > 14) {
                arr['eventype']++;
                arr['type4']++;
            }



        });

        setChartStatistic(arr);

        setMounted(true);


    });

    if (!mounted) return;

    return (
        <>
            <div className="result-wrapper mt-5">
                <div className="chart-title">
                    <label>통계데이터 - <span className="text-red">ScorePlus365</span></label>
                </div>

                <div className="chart-statistic-indicator">
                    <div className="left-section">
                        <div className="game-ball-result-wrapper">
                            <label>파워볼</label>
                            <BluePercentIndicator left={'좌'} right={'우'} leftText={ChartStatistic['left']} rightText={ChartStatistic['right']} />
                            <BluePercentIndicator left={'3'} right={'4'} leftText={ChartStatistic['3Line']} rightText={ChartStatistic['4Line']} />
                            <BluePercentIndicator left={'홀'} right={'짝'} leftText={ChartStatistic['oddtype']} rightText={ChartStatistic['eventype']} />
                        </div>

                    </div>

                    <div className="right-section">
                        <PieSizeChart
                            t1={ChartStatistic['type1']}
                            t2={ChartStatistic['type2']}
                            t3={ChartStatistic['type3']}
                            t4={ChartStatistic['type4']}
                        />
                    </div>
                </div>
            </div>
        </>
    )
});


const BluePercentIndicator = ((props) => {
    let leftPercent = (props.leftText / (props.leftText + props.rightText)) * 100;
    let rightPercent = (props.rightText / (props.leftText + props.rightText)) * 100;
    return (
        <>
            <div className="chart-percentage-indicator">
                <div className="side-label app-circle blue">{props.left}</div>
                <div className="center-label text-right">
                    <label>{props.leftText} ({leftPercent.toFixed(2)}%)</label>
                    <div className="inner-indicator blue-indicator" style={{ width: '40%' }}>{props.rightText} ({rightPercent.toFixed(2)}%)</div>
                </div>
                <div className="side-label ">{props.right}</div>
            </div>
        </>
    )
});

const PieSizeChart = ((props) => {
    console.log(props)
    let data1 = (props.t1 / (props.t1 + props.t2 + props.t3 + props.t4)) * 100;
    let data2 = (props.t2 / (props.t1 + props.t2 + props.t3 + props.t4)) * 100;
    let data3 = (props.t3 / (props.t1 + props.t2 + props.t3 + props.t4)) * 100;
    let data4 = (props.t4 / (props.t1 + props.t2 + props.t3 + props.t4)) * 100;

    return (
        <>
            <div className="pie-wrapper">
                <div className="SizePie" ></div>
                <ul>
                    <li><div className="color-label blue"></div>좌4홀 : {props.t1}회 ({data1.toFixed(2)}%) </li>
                    <li ><div className="color-label blue1"></div>우3홀 : {props.t2}회 ({data2.toFixed(2)}%) </li>
                    <li><div className="color-label red"></div>좌3짝 : {props.t3}회 ({data3.toFixed(2)}%) </li>
                    <li><div className="color-label red1"></div>우4짝 : {props.t4}회 ({data4.toFixed(2)}%) </li>
                </ul>
            </div>
        </>
    )
});


export default ChartStyle;